import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const brandApi = createApi({
  reducerPath: 'brandApi',
  baseQuery: createBaseQuery('brands'),
  endpoints: builder => ({
    getBrand: builder.query({
      query: id => `/${id}`,
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useLazyGetBrandQuery } = brandApi;
